import { render } from "./ErrorDialog.vue?vue&type=template&id=344feb61&scoped=true"
import script from "./ErrorDialog.vue?vue&type=script&lang=js"
export * from "./ErrorDialog.vue?vue&type=script&lang=js"

import "./ErrorDialog.vue?vue&type=style&index=0&id=344feb61&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-344feb61"]])

export default __exports__